<template>
	<div>
		<base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-pink">
			<!-- Card stats -->
			<b-row>
				<b-col xl="3" md="6">
					<stats-card title="CIUDAD" type="gradient-red" icon="ni ni-active-40" class="mb-4">
						<template slot="footer">
							<div>
								<input
									type="text"
									placeholder="Ingresa una ubicación"
									id="autocompletemoreira"
									style="width: 100% font-weight:black"
									class="mb-4"
								/>
								<br />
								<br />
							</div>
						</template>
					</stats-card>
				</b-col>
				<b-col xl="3" md="6">
					<stats-card
						title="TIPO DE REGISTRO"
						type="gradient-orange"
						icon="ni ni-chart-pie-35"
						class="mb-4"
					>
						<template slot="footer">
							<div id="app1">
								<select class="form-control-file" @change="changetipoRegistro($event)">
									<option value selected disabled>Seleccione el tipo de registro</option>
									<option
										v-for="tipoRegistro in tipoRegistros"
										:value="tipoRegistro.id"
										:key="tipoRegistro.id"
									>{{ tipoRegistro.name }}</option>
								</select>
								<br />
								<span>Registros de</span>
								<span style="font-weight: bold">{{ selectedtipoRegistro }}</span>
							</div>
						</template>
					</stats-card>
				</b-col>
				<b-col xl="3" md="6">
					<stats-card
						title="VALOR DE REGISTRO"
						type="gradient-green"
						icon="ni ni-money-coins"
						class="mb-4"
					>
						<template slot="footer">
							<div v-if="selectedtipoRegistro === 'Inmueble'">
								<select class="form-control-file" @change="changevalorRegistro($event)">
									<option value selected disabled>Seleccione el valor del registro</option>
									<option
										v-for="valorRegistro in valorRegistros"
										:value="valorRegistro.id"
										:key="valorRegistro.id"
									>{{ valorRegistro.name }}</option>
								</select>
								<br />

								<span>Valor seleccionado</span>
								<span style="font-weight: bold">{{ selectedvalorRegistro }}</span>
							</div>
							<div v-else-if="selectedtipoRegistro === 'Planta Externa'">
								<select class="form-control-file" @change="changevalorPlantaExterna($event)">
									<option value selected disabled>Seleccione el valor del registro</option>
									<option
										v-for="valorPlantaExterna in valorPlantaExternas"
										:value="valorPlantaExterna.id"
										:key="valorPlantaExterna.id"
									>{{ valorPlantaExterna.name }}</option>
								</select>
								<br />

								<span>Valor seleccionado</span>
								<span style="font-weight: bold">{{ selectedvalorPlantaExterna }}</span>
							</div>
							<div v-else>
								<select class="form-control-file" @change="changevalorPlantaExterna($event)">
									<option value selected disabled>Seleccione el valor del registro</option>
									<option>{{ "" }}</option>
								</select>
								<br />

								<span>Valor seleccionado: {{ selectedvalorPlantaExterna }}</span>
							</div>
						</template>
					</stats-card>
				</b-col>
				<b-col xl="3" md="6">
					<stats-card
						title="TOTAL REGISTROS RESULTANTES"
						type="gradient-green "
						icon="ni ni-money-coins"
						class="mb-4"
					>
						<template slot="footer">
							<h1 class="text-success mr-6">{{ totalRegistros }}</h1>
						</template>
					</stats-card>
				</b-col>
			</b-row>

			<div class="tw-flex tw-justify-between tw-items-center">
				<div>
					<!-- v-model="ad" -->
					<b-button @click="aplicarFiltros">Aplicar Filtros</b-button>
					<b-button @click="deleteSelectedShape">Borrar Polygono</b-button>
				</div>
				<div class="tw-bg-white tw-rounded tw-shadow-md tw-py-2 tw-px-4">
					<b-form-group v-slot="{ ariaDescribedby }" class="tw-mb-0">
						<b-form-radio-group
							:options="collections"
							:aria-describedby="ariaDescribedby"
							v-model="selectedCollection"
						></b-form-radio-group>
					</b-form-group>
				</div>
			</div>
		</base-header>

		<b-container fluid class="mt--7">
			<b-row>
				<b-col>
					<b-card style="width: 100%; height: 500px">
						<gmap-map id="map" ref="mapRef" :center="{}"></gmap-map>
						<div id="sidebar"></div>
					</b-card>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
import axios from "axios";
import { db } from '../firebase';
import { gmapApi } from 'vue2-google-maps'
// import firebase from "firebase/compat/app";
// import "firebase/compat/firestore";

// const firebaseConfig = {
// 	apiKey: "AIzaSyAVAPuU89LgvU20UMzDStU1nerH2Zb2qXA",
// 	authDomain: "vlactest01.firebaseapp.com",
// 	databaseURL: "https://vlactest01-default-rtdb.firebaseio.com",
// 	projectId: "vlactest01",
// 	storageBucket: "vlactest01.appspot.com",
// 	messagingSenderId: "259263606119",
// 	appId: "1:259263606119:web:e11295c0ecb61c2847d3c2",
// 	measurementId: "G-K6YVZQNM17",
// };
// firebase.initializeApp(firebaseConfig);
// const db = firebase.firestore();
let centroMapa;
let selectedShape;


export default {
	name: "app1",
	mounted() {

		// const
		// injectScript(

		// )

		this.$refs.mapRef.$mapPromise.then(map => {
			console.log('this.google', this.google)
			let autocomplete = new this.google.maps.places.Autocomplete(
				document.getElementById("autocompletemoreira"),
				{
					bounds: new this.google.maps.LatLngBounds(new this.google.maps.LatLng()),
					componentRestrictions: { country: "ECU" },
				}
			);
			autocomplete.addListener("place_changed", () => {
				centroMapa = autocomplete.getPlace();
				console.log(centroMapa, "AQUIIIESTABIEN");
				this.showUserLocationOnTheMap(
					centroMapa.geometry.location.lat(),
					centroMapa.geometry.location.lng()
				);
			});

			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(
					(position) => {
						console.log(position.coords.latitude);
						console.log(position.coords.longitude + "mi latlong");
						this.showUserLocationOnTheMap(
							position.coords.latitude,
							position.coords.longitude
						);
					},
					(error) => {
						console.log(error.message);
					}
				);
			} else {
				console.log("NO ESTA FUNCIONANDO");
			}
		})



	},
	getAddressFrom(lat, long) {
		axios
			.get(
				"https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
				lat +
				"," +
				long +
				"&key=AIzaSyDtgz9_16qdAHXWPwzhnpNLJKBUR_THdYc"
			)
			.then((response) => {
				if (response.data.error_message) {
					console.log(response.data.error_message);
				} else {
					console.log(response.data.results[0].formatted_address);
				}
			})
			.catch((error) => {
				console.log(error.message);
			});
	},
	data() {
		return {
			ad: null,
			selectedCollection: 'Solicitudes',
			collections: [
				{ text: 'App Movil', value: 'inmobiliario' },
				{ text: 'Avaluos', value: 'Solicitudes' },
				{ text: 'Plusvalia', value: 'Plusvalia' },
			],
			tipoRegistros: [
				{ name: "Planta Externa", id: 1 },
				{ name: "Inmueble", id: 2 },
				{ name: "Todos", id: 3 },
			],
			selectedtipoRegistro: null,
			valorRegistros: [
				{ name: "Todos", id: 0 },
				{ name: "Casa", id: 1 },
				{ name: "Galpon", id: 2 },
				{ name: "Terreno", id: 3 },
				{ name: "Departamento", id: 4 },
				{ name: "Oficina", id: 5 },
				{ name: "Inmueble", id: 6 },
			],
			selectedvalorRegistro: null,
			valorPlantaExternas: [
				{ name: "Todos", id: 0 },
				{ name: "Redes Aereas", id: 1 },
				{ name: "Subterraneas", id: 2 },
				{ name: "Materiales y Equipos", id: 3 },
				{ name: "Circuito Expreso", id: 4 },
				{ name: "Planta Externa", id: 5 },
			],
			selectedvalorPlantaExterna: null,
			totalRegistros: null,
		};
	},
	computed: {
		google: gmapApi,
	},
	methods: {
		changetipoRegistro(event) {
			this.selectedtipoRegistro =
				event.target.options[event.target.options.selectedIndex].text;
		},
		changevalorRegistro(event) {
			this.selectedvalorRegistro =
				event.target.options[event.target.options.selectedIndex].text;
		},
		changevalorPlantaExterna(event) {
			this.selectedvalorPlantaExterna =
				event.target.options[event.target.options.selectedIndex].text;
		},
		aplicarFiltros() {

			let tipoReg = "tipoRegistro";
			let comparative;
			let valorSel;
			if (
				(this.selectedvalorRegistro == null &&
					this.selectedvalorPlantaExterna == null) ||
				this.selectedvalorRegistro == "Todos"
			) {
				comparative = "in";
				if (
					this.selectedtipoRegistro == "Planta Externa" ||
					(this.selectedtipoRegistro == "Planta Externa" &&
						this.selectedvalorRegistro == "Todos")
				) {
					valorSel = [
						"redAerea",
						"subterranea",
						"circuito",
						"plantaExterna",
						"materiales",
					];
				} else if (
					this.selectedtipoRegistro == "Inmueble" ||
					(this.selectedtipoRegistro == "Inmueble" &&
						this.selectedvalorRegistro == "Todos")
				) {
					valorSel = [
						"casa",
						"terreno",
						"galpon",
						"departamento",
						"oficina",
						"inmueble",
					];
				} else if (
					this.selectedtipoRegistro == null ||
					this.selectedtipoRegistro == "Todos"
				) {
					valorSel = [
						"redAerea",
						"subterranea",
						"circuito",
						"plantaExterna",
						"materiales",
						"casa",
						"terreno",
						"galpon",
						"departamento",
						"oficina",
						//completar filtros 10 maximo
					];
				}
			} else {
				console.log("existe valor de registro");
				comparative = "==";
				if (this.selectedtipoRegistro == "Inmueble") {
					switch (this.selectedvalorRegistro) {
						case "Galpon":
							valorSel = "galpon";
							break;
						case "Terreno":
							valorSel = "terreno";
							break;
						case "Casa":
							valorSel = "casa";
							break;
						case "Departamento":
							valorSel = "departamento";
							break;
						case "Oficina":
							valorSel = "oficina";
							break;
						case "Inmueble":
							valorSel = "inmueble";
							break;
					}
				}
				if (this.selectedtipoRegistro == "Planta Externa") {
					switch (this.selectedvalorPlantaExterna) {
						case "Redes Aereas":
							valorSel = "redAerea";
							break;
						case "Subterraneas":
							valorSel = "subterranea";
							break;
						case "Materiales y Equipos":
							valorSel = "material";
							break;
						case "Circuito Expreso":
							valorSel = "circuito";
							break;
						case "Planta Externa":
							valorSel = "plantaExterna";
							break;
					}
				}
				if (this.selectedtipoRegistro == "Todos") {
					switch (this.selectedvalorPlantaExterna) {
						case "Redes Aereas":
							valorSel = "redAerea";
							break;
						case "Subterraneas":
							valorSel = "subterranea";
							break;
						case "Materiales y Equipos":
							valorSel = "material";
							break;
						case "Circuito Expreso":
							valorSel = "circuito";
							break;
						case "Planta Externa":
							valorSel = "plantaExterna";
							break;
					}
				}
			}
			console.log(tipoReg + "    " + comparative + "    " + valorSel);
			const mCasa = require("../assets/casa24.png");
			const mTerreno = require("../assets/terreno24.png");
			const mOficina = require("../assets/oficina24.png");
			const mGalpon = require("../assets/galpon24.png");
			const mDepartamento = require("../assets/departamento24.png");
			const mInmueble = require("../assets/inmueble24.png");
			const mredAerea = require("../assets/redaerea24.png");
			const mSubterranea = require("../assets/subterranea24.png");
			const mMaterial = require("../assets/material24.png");
			const mCicuito = require("../assets/circuito24.png");
			const mPlantaExterna = require("../assets/plantaex24.png");

			console.log(tipoReg, comparative, valorSel)
			db.collection(this.selectedCollection)
				.where(tipoReg, comparative, valorSel)
				.get()
				.then((querySnapshot) => {
					this.totalRegistros = querySnapshot.size.toString();

					const map = new this.google.maps.Map(document.getElementById("map"), {
						zoom: 13,
						center: new this.google.maps.LatLng(
							centroMapa.geometry.location.lat(),
							centroMapa.geometry.location.lng()
						),
						mapTypeId: this.google.maps.MapTypeId.ROADMAP,
					});

					querySnapshot.forEach((doc) => {
						//crear marcador si es casa
						if (doc.data().tipoRegistro == "casa") {
							let marker = new this.google.maps.Marker({
								position: new this.google.maps.LatLng(
									doc.data().ubicacion.latitude,
									doc.data().ubicacion.longitude
								),
								title: "CASA",
								icon: mCasa,

								map: map,
							});
							let infoWindow = new this.google.maps.InfoWindow({
								content: "$ " + doc.data().precio,
							});
							marker.addListener("click", function () {
								infoWindow.open(map, marker);
							});
						}
						//crear marcador si es terreno
						if (doc.data().tipoRegistro == "terreno") {
							let marker = new this.google.maps.Marker({
								position: new this.google.maps.LatLng(
									doc.data().ubicacion.latitude,
									doc.data().ubicacion.longitude
								),
								icon: mTerreno,
								title: "TERRENO",
								map: map,
							});
							let infoWindow = new this.google.maps.InfoWindow({
								content: "$ " + doc.data().precio,
							});
							marker.addListener("click", function () {
								infoWindow.open(map, marker);
							});
						}
						//crear marcador si es oficina
						if (doc.data().tipoRegistro == "oficina") {
							let marker = new this.google.maps.Marker({
								position: new this.google.maps.LatLng(
									doc.data().ubicacion.latitude,
									doc.data().ubicacion.longitude
								),
								icon: mOficina,
								title: "OFICINA",
								map: map,
							});
							let infoWindow = new this.google.maps.InfoWindow({
								content: "$ " + doc.data().precio,
							});
							marker.addListener("click", function () {
								infoWindow.open(map, marker);
							});
						}
						//crear marcador si es departamento
						if (doc.data().tipoRegistro == "departamento") {
							let marker = new this.google.maps.Marker({
								position: new this.google.maps.LatLng(
									doc.data().ubicacion.latitude,
									doc.data().ubicacion.longitude
								),
								icon: mDepartamento,
								title: "DEPARTAMENTO",
								map: map,
							});
							let infoWindow = new this.google.maps.InfoWindow({
								content: "$ " + doc.data().precio,
							});
							marker.addListener("click", function () {
								infoWindow.open(map, marker);
							});
						}
						//crear marcador si es galpon
						if (doc.data().tipoRegistro == "galpon") {
							let marker = new this.google.maps.Marker({
								position: new this.google.maps.LatLng(
									doc.data().ubicacion.latitude,
									doc.data().ubicacion.longitude
								),
								icon: mGalpon,
								title: "GALPON",
								map: map,
							});
							let infoWindow = new this.google.maps.InfoWindow({
								content: "$ " + doc.data().precio,
							});
							marker.addListener("click", function () {
								infoWindow.open(map, marker);
							});
						}

						//crear marcador si es plantaExterna
						if (doc.data().tipoRegistro == "plantaExterna") {
							let marker = new this.google.maps.Marker({
								position: new this.google.maps.LatLng(
									doc.data().ubicacion.latitude,
									doc.data().ubicacion.longitude
								),
								icon: mPlantaExterna,
								title: "Planta Externa",
								map: map,
							});
							let infoWindow = new this.google.maps.InfoWindow({
								content: "Planta Externa",
							});
							marker.addListener("click", function () {
								infoWindow.open(map, marker);
							});
						}

						//crear marcador si es subterranea
						if (doc.data().tipoRegistro == "subterranea") {
							let marker = new this.google.maps.Marker({
								position: new this.google.maps.LatLng(
									doc.data().ubicacion.latitude,
									doc.data().ubicacion.longitude
								),
								icon: mSubterranea,
								title: "RED SUBTERRANEA",
								map: map,
							});
							let infoWindow = new this.google.maps.InfoWindow({
								content: "Subterraneo",
							});
							marker.addListener("click", function () {
								infoWindow.open(map, marker);
							});
						}
						//crear marcador si es inmueble
						if (doc.data().tipoRegistro == "inmueble") {
							let marker = new this.google.maps.Marker({
								position: new this.google.maps.LatLng(
									doc.data().ubicacion.latitude,
									doc.data().ubicacion.longitude
								),
								icon: mInmueble,
								title: "INMUEBLE",
								map: map,
							});
							let infoWindow = new this.google.maps.InfoWindow({
								content: "$ " + doc.data().precio,
							});
							marker.addListener("click", function () {
								infoWindow.open(map, marker);
							});
						}
						//crear marcador si es redAerea
						if (doc.data().tipoRegistro == "redAerea") {
							let marker = new this.google.maps.Marker({
								position: new this.google.maps.LatLng(
									doc.data().ubicacion.latitude,
									doc.data().ubicacion.longitude
								),
								icon: mredAerea,
								title: "RED AEREA",
								map: map,
							});
							let infoWindow = new this.google.maps.InfoWindow({
								content: "Red Aerea",
							});
							marker.addListener("click", function () {
								infoWindow.open(map, marker);
							});
						}
						//crear marcador si es material
						if (doc.data().tipoRegistro == "material") {
							let marker = new this.google.maps.Marker({
								position: new this.google.maps.LatLng(
									doc.data().ubicacion.latitude,
									doc.data().ubicacion.longitude
								),
								icon: mMaterial,
								title: "MATERIAL",
								map: map,
							});
							let infoWindow = new this.google.maps.InfoWindow({
								content: "Material",
							});
							marker.addListener("click", function () {
								infoWindow.open(map, marker);
							});
						}
						//crear marcador si es circuito
						if (doc.data().tipoRegistro == "circuito") {
							let marker = new this.google.maps.Marker({
								position: new this.google.maps.LatLng(
									doc.data().ubicacion.latitude,
									doc.data().ubicacion.longitude
								),
								icon: mCicuito,
								title: "CIRCUITO EXPRESO",
								map: map,
							});
							let infoWindow = new this.google.maps.InfoWindow({
								content: "Circuito Expreso",
							});
							marker.addListener("click", function () {
								infoWindow.open(map, marker);
							});
						}
					});
				})
				.catch((error) => {
					console.log("Error getting documents: ", error);
				});
			this.selectedvalorRegistro = null;
			//this.selectedtipoRegistro = null
			this.selectedvalorPlantaExterna = null;
			console.log(this.selectedtipoRegistro + "TR");
			console.log(this.selectedvalorRegistro + "VR");
			console.log(this.selectedvalorPlantaExterna + "PE");
		},

		showUserLocationOnTheMap(latitude, longitude) {
			console.log("AQUI ESTA CREAADO EL MAPA", this.google);
			//crear mapa

			let map = new this.google.maps.Map(document.getElementById("map"), {
				zoom: 13,
				center: new this.google.maps.LatLng(latitude, longitude),
				mapTypeId: this.google.maps.MapTypeId.ROADMAP,
			});
			new this.google.maps.Marker({
				position: new this.google.maps.LatLng(latitude, longitude),
				title: "Ubicacion Actual",
				map: map,
			});
			var drawingManager = new this.google.maps.drawing.DrawingManager({
				drawingControl: true,
				drawingControlOptions: {
					position: this.google.maps.ControlPosition.BOTTON_CENTER,
					drawingModes: [
						this.google.maps.drawing.OverlayType.CIRCLE,
						this.google.maps.drawing.OverlayType.RECTANGLE,
					],
				},

				circleOptions: {
					clickable: false,
					editable: false,
					draggable: false,
				},
				polylineOptions: {
					editable: true,
				},

				map: map,
			});

			this.google.maps.event.addListener(
				drawingManager,
				"overlaycomplete",
				function (event) {
					const mCasa = require("../assets/casa24.png");
					const mTerreno = require("../assets/terreno24.png");
					const mOficina = require("../assets/oficina24.png");
					const mGalpon = require("../assets/galpon24.png");
					const mDepartamento = require("../assets/departamento24.png");
					const mInmueble = require("../assets/inmueble24.png");
					const mredAerea = require("../assets/redaerea24.png");
					const mSubterranea = require("../assets/subterranea24.png");
					const mMaterial = require("../assets/material24.png");
					const mCicuito = require("../assets/circuito24.png");
					const mPlantaExterna = require("../assets/plantaex24.png");
					console.log(this.selectedtipoRegistro + "danyyyyy");
					let tipoReg = "tipoRegistro";
					let comparative;
					let valorSel;
					if (
						(this.selectedvalorRegistro == null &&
							this.selectedvalorPlantaExterna == null) ||
						this.selectedvalorRegistro == "Todos"
					) {
						comparative = "in";
						if (this.selectedtipoRegistro == "Planta Externa") {
							valorSel = [
								"redAerea",
								"subterranea",
								"circuito",
								"plantaExterna",
								"materiales",
							];
						} else if (this.selectedtipoRegistro == "Inmueble") {
							valorSel = [
								"casa",
								"terreno",
								"galpon",
								"departamento",
								"oficina",
								"inmueble",
							];
						} else if (
							this.selectedtipoRegistro == null ||
							this.selectedtipoRegistro == "Todos"
						) {
							valorSel = [
								"redAerea",
								"subterranea",
								"circuito",
								"plantaExterna",
								"materiales",
								"casa",
								"terreno",
								"galpon",
								"departamento",
								"oficina",
								//completar filtros 10 maximo
							];
						}
					} else {
						console.log("existe valor de registro");
						comparative = "==";
						if (this.selectedtipoRegistro == "Inmueble") {
							switch (this.selectedvalorRegistro) {
								case "Galpon":
									valorSel = "galpon";
									break;
								case "Terreno":
									valorSel = "terreno";
									break;
								case "Casa":
									valorSel = "casa";
									break;
								case "Departamento":
									valorSel = "departamento";
									break;
								case "Oficina":
									valorSel = "oficina";
									break;
								case "Inmueble":
									valorSel = "inmueble";
									break;
							}
						}
						if (this.selectedtipoRegistro == "Planta Externa") {
							switch (this.selectedvalorPlantaExterna) {
								case "Redes Aereas":
									valorSel = "redAerea";
									break;
								case "Subterraneas":
									valorSel = "subterranea";
									break;
								case "Materiales y Equipos":
									valorSel = "material";
									break;
								case "Circuito Expreso":
									valorSel = "circuito";
									break;
								case "Planta Externa":
									valorSel = "plantaExterna";
									break;
							}
						}
					}
					if (event.type == this.google.maps.drawing.OverlayType.CIRCLE) {
						console.log(this.selectedtipoRegistro + "TR");
						console.log(this.selectedvalorRegistro + "VR");
						console.log(this.selectedvalorPlantaExterna + "PE");
						var radius = event.overlay.getRadius();
						console.log(radius + "DIBUJASTE UN CIRCULO");
						db.collection("inmobiliario")
							.where(tipoReg, comparative, valorSel)
							.get()
							.then((querySnapshot) => {
								this.totalRegistros = querySnapshot.size.toString();

								const map = new this.google.maps.Map(
									document.getElementById("map"),
									{
										zoom: 13,
										center: new this.google.maps.LatLng(
											centroMapa.geometry.location.lat(),
											centroMapa.geometry.location.lng()
										),
										mapTypeId: this.google.maps.MapTypeId.ROADMAP,
									}
								);

								querySnapshot.forEach((doc) => {
									var point = new this.google.maps.LatLng(
										doc.data().ubicacion.latitude,
										doc.data().ubicacion.longitude
									);
									console.log(event.type);

									if (
										this.google.maps.geometry.spherical.computeDistanceBetween(
											point,
											event.overlay.getCenter()
										) <= event.overlay.getRadius()
									) {
										console.log("=> is in searchArea");

										//crear marcador si es casa
										if (doc.data().tipoRegistro == "casa") {
											let marker = new this.google.maps.Marker({
												position: new this.google.maps.LatLng(
													doc.data().ubicacion.latitude,
													doc.data().ubicacion.longitude
												),
												title: "CASA",
												icon: mCasa,

												map: map,
											});
											let infoWindow = new this.google.maps.InfoWindow({
												content: "$ " + doc.data().precio,
											});
											marker.addListener("click", function () {
												infoWindow.open(map, marker);
											});
										}
										//crear marcador si es terreno
										if (doc.data().tipoRegistro == "terreno") {
											let marker = new this.google.maps.Marker({
												position: new this.google.maps.LatLng(
													doc.data().ubicacion.latitude,
													doc.data().ubicacion.longitude
												),
												icon: mTerreno,
												title: "TERRENO",
												map: map,
											});
											let infoWindow = new this.google.maps.InfoWindow({
												content: "$ " + doc.data().precio,
											});
											marker.addListener("click", function () {
												infoWindow.open(map, marker);
											});
										}
										//crear marcador si es oficina
										if (doc.data().tipoRegistro == "oficina") {
											let marker = new this.google.maps.Marker({
												position: new this.google.maps.LatLng(
													doc.data().ubicacion.latitude,
													doc.data().ubicacion.longitude
												),
												icon: mOficina,
												title: "OFICINA",
												map: map,
											});
											let infoWindow = new this.google.maps.InfoWindow({
												content: "$ " + doc.data().precio,
											});
											marker.addListener("click", function () {
												infoWindow.open(map, marker);
											});
										}
										//crear marcador si es departamento
										if (doc.data().tipoRegistro == "departamento") {
											let marker = new this.google.maps.Marker({
												position: new this.google.maps.LatLng(
													doc.data().ubicacion.latitude,
													doc.data().ubicacion.longitude
												),
												icon: mDepartamento,
												title: "DEPARTAMENTO",
												map: map,
											});
											let infoWindow = new this.google.maps.InfoWindow({
												content: "$ " + doc.data().precio,
											});
											marker.addListener("click", function () {
												infoWindow.open(map, marker);
											});
										}
										//crear marcador si es galpon
										if (doc.data().tipoRegistro == "galpon") {
											let marker = new this.google.maps.Marker({
												position: new this.google.maps.LatLng(
													doc.data().ubicacion.latitude,
													doc.data().ubicacion.longitude
												),
												icon: mGalpon,
												title: "GALPON",
												map: map,
											});
											let infoWindow = new this.google.maps.InfoWindow({
												content: "$ " + doc.data().precio,
											});
											marker.addListener("click", function () {
												infoWindow.open(map, marker);
											});
										}

										//crear marcador si es plantaExterna
										if (doc.data().tipoRegistro == "plantaExterna") {
											let marker = new this.google.maps.Marker({
												position: new this.google.maps.LatLng(
													doc.data().ubicacion.latitude,
													doc.data().ubicacion.longitude
												),
												icon: mPlantaExterna,
												title: "Planta Externa",
												map: map,
											});
											let infoWindow = new this.google.maps.InfoWindow({
												content: "Planta Externa",
											});
											marker.addListener("click", function () {
												infoWindow.open(map, marker);
											});
										}

										//crear marcador si es subterranea
										if (doc.data().tipoRegistro == "subterranea") {
											let marker = new this.google.maps.Marker({
												position: new this.google.maps.LatLng(
													doc.data().ubicacion.latitude,
													doc.data().ubicacion.longitude
												),
												icon: mSubterranea,
												title: "RED SUBTERRANEA",
												map: map,
											});
											let infoWindow = new this.google.maps.InfoWindow({
												content: "Subterraneo",
											});
											marker.addListener("click", function () {
												infoWindow.open(map, marker);
											});
										}
										//crear marcador si es inmueble
										if (doc.data().tipoRegistro == "inmueble") {
											let marker = new this.google.maps.Marker({
												position: new this.google.maps.LatLng(
													doc.data().ubicacion.latitude,
													doc.data().ubicacion.longitude
												),
												icon: mInmueble,
												title: "INMUEBLE",
												map: map,
											});
											let infoWindow = new this.google.maps.InfoWindow({
												content: "$ " + doc.data().precio,
											});
											marker.addListener("click", function () {
												infoWindow.open(map, marker);
											});
										}
										//crear marcador si es redAerea
										if (doc.data().tipoRegistro == "redAerea") {
											let marker = new this.google.maps.Marker({
												position: new this.google.maps.LatLng(
													doc.data().ubicacion.latitude,
													doc.data().ubicacion.longitude
												),
												icon: mredAerea,
												title: "RED AEREA",
												map: map,
											});
											let infoWindow = new this.google.maps.InfoWindow({
												content: "Red Aerea",
											});
											marker.addListener("click", function () {
												infoWindow.open(map, marker);
											});
										}
										//crear marcador si es material
										if (doc.data().tipoRegistro == "material") {
											let marker = new this.google.maps.Marker({
												position: new this.google.maps.LatLng(
													doc.data().ubicacion.latitude,
													doc.data().ubicacion.longitude
												),
												icon: mMaterial,
												title: "MATERIAL",
												map: map,
											});
											let infoWindow = new this.google.maps.InfoWindow({
												content: "Material",
											});
											marker.addListener("click", function () {
												infoWindow.open(map, marker);
											});
										}
										//crear marcador si es circuito
										if (doc.data().tipoRegistro == "circuito") {
											let marker = new this.google.maps.Marker({
												position: new this.google.maps.LatLng(
													doc.data().ubicacion.latitude,
													doc.data().ubicacion.longitude
												),
												icon: mCicuito,
												title: "CIRCUITO EXPRESO",
												map: map,
											});
											let infoWindow = new this.google.maps.InfoWindow({
												content: "Circuito Expreso",
											});
											marker.addListener("click", function () {
												infoWindow.open(map, marker);
											});
										}
									} else {
										console.log("=> is NOT in searchArea");
									}
								});
							})
							.catch((error) => {
								console.log("Error getting documents: ", error);
							});
					} else if (event.type == this.google.maps.drawing.OverlayType.RECTANGLE) {
						console.log("DIBUJASTE UN rect");
						db.collection("inmobiliario")
							.where(tipoReg, comparative, valorSel)
							.get()
							.then((querySnapshot) => {
								this.totalRegistros = querySnapshot.size.toString();

								const map = new this.google.maps.Map(
									document.getElementById("map"),
									{
										zoom: 13,
										center: new this.google.maps.LatLng(
											centroMapa.geometry.location.lat(),
											centroMapa.geometry.location.lng()
										),
										mapTypeId: this.google.maps.MapTypeId.ROADMAP,
									}
								);

								querySnapshot.forEach((doc) => {
									var point = new this.google.maps.LatLng(
										doc.data().ubicacion.latitude,
										doc.data().ubicacion.longitude
									);
									console.log(event.type);

									let insideRectangle = event.overlay
										.getBounds()
										.contains(point);
									console.log(insideRectangle);

									if (insideRectangle == true) {
										console.log("=> is in searchArea");

										//crear marcador si es casa
										if (doc.data().tipoRegistro == "casa") {
											let marker = new this.google.maps.Marker({
												position: new this.google.maps.LatLng(
													doc.data().ubicacion.latitude,
													doc.data().ubicacion.longitude
												),
												title: "CASA",
												icon: mCasa,

												map: map,
											});
											let infoWindow = new this.google.maps.InfoWindow({
												content: "$ " + doc.data().precio,
											});
											marker.addListener("click", function () {
												infoWindow.open(map, marker);
											});
										}
										//crear marcador si es terreno
										if (doc.data().tipoRegistro == "terreno") {
											let marker = new this.google.maps.Marker({
												position: new this.google.maps.LatLng(
													doc.data().ubicacion.latitude,
													doc.data().ubicacion.longitude
												),
												icon: mTerreno,
												title: "TERRENO",
												map: map,
											});
											let infoWindow = new this.google.maps.InfoWindow({
												content: "$ " + doc.data().precio,
											});
											marker.addListener("click", function () {
												infoWindow.open(map, marker);
											});
										}
										//crear marcador si es oficina
										if (doc.data().tipoRegistro == "oficina") {
											let marker = new this.google.maps.Marker({
												position: new this.google.maps.LatLng(
													doc.data().ubicacion.latitude,
													doc.data().ubicacion.longitude
												),
												icon: mOficina,
												title: "OFICINA",
												map: map,
											});
											let infoWindow = new this.google.maps.InfoWindow({
												content: "$ " + doc.data().precio,
											});
											marker.addListener("click", function () {
												infoWindow.open(map, marker);
											});
										}
										//crear marcador si es departamento
										if (doc.data().tipoRegistro == "departamento") {
											let marker = new this.google.maps.Marker({
												position: new this.google.maps.LatLng(
													doc.data().ubicacion.latitude,
													doc.data().ubicacion.longitude
												),
												icon: mDepartamento,
												title: "DEPARTAMENTO",
												map: map,
											});
											let infoWindow = new this.google.maps.InfoWindow({
												content: "$ " + doc.data().precio,
											});
											marker.addListener("click", function () {
												infoWindow.open(map, marker);
											});
										}
										//crear marcador si es galpon
										if (doc.data().tipoRegistro == "galpon") {
											let marker = new this.google.maps.Marker({
												position: new this.google.maps.LatLng(
													doc.data().ubicacion.latitude,
													doc.data().ubicacion.longitude
												),
												icon: mGalpon,
												title: "GALPON",
												map: map,
											});
											let infoWindow = new this.google.maps.InfoWindow({
												content: "$ " + doc.data().precio,
											});
											marker.addListener("click", function () {
												infoWindow.open(map, marker);
											});
										}

										//crear marcador si es plantaExterna
										if (doc.data().tipoRegistro == "plantaExterna") {
											let marker = new this.google.maps.Marker({
												position: new this.google.maps.LatLng(
													doc.data().ubicacion.latitude,
													doc.data().ubicacion.longitude
												),
												icon: mPlantaExterna,
												title: "Planta Externa",
												map: map,
											});
											let infoWindow = new this.google.maps.InfoWindow({
												content: "Planta Externa",
											});
											marker.addListener("click", function () {
												infoWindow.open(map, marker);
											});
										}

										//crear marcador si es subterranea
										if (doc.data().tipoRegistro == "subterranea") {
											let marker = new this.google.maps.Marker({
												position: new this.google.maps.LatLng(
													doc.data().ubicacion.latitude,
													doc.data().ubicacion.longitude
												),
												icon: mSubterranea,
												title: "RED SUBTERRANEA",
												map: map,
											});
											let infoWindow = new this.google.maps.InfoWindow({
												content: "Subterraneo",
											});
											marker.addListener("click", function () {
												infoWindow.open(map, marker);
											});
										}
										//crear marcador si es inmueble
										if (doc.data().tipoRegistro == "inmueble") {
											let marker = new this.google.maps.Marker({
												position: new this.google.maps.LatLng(
													doc.data().ubicacion.latitude,
													doc.data().ubicacion.longitude
												),
												icon: mInmueble,
												title: "INMUEBLE",
												map: map,
											});
											let infoWindow = new this.google.maps.InfoWindow({
												content: "$ " + doc.data().precio,
											});
											marker.addListener("click", function () {
												infoWindow.open(map, marker);
											});
										}
										//crear marcador si es redAerea
										if (doc.data().tipoRegistro == "redAerea") {
											let marker = new this.google.maps.Marker({
												position: new this.google.maps.LatLng(
													doc.data().ubicacion.latitude,
													doc.data().ubicacion.longitude
												),
												icon: mredAerea,
												title: "RED AEREA",
												map: map,
											});
											let infoWindow = new this.google.maps.InfoWindow({
												content: "Red Aerea",
											});
											marker.addListener("click", function () {
												infoWindow.open(map, marker);
											});
										}
										//crear marcador si es material
										if (doc.data().tipoRegistro == "material") {
											let marker = new this.google.maps.Marker({
												position: new this.google.maps.LatLng(
													doc.data().ubicacion.latitude,
													doc.data().ubicacion.longitude
												),
												icon: mMaterial,
												title: "MATERIAL",
												map: map,
											});
											let infoWindow = new this.google.maps.InfoWindow({
												content: "Material",
											});
											marker.addListener("click", function () {
												infoWindow.open(map, marker);
											});
										}
										//crear marcador si es circuito
										if (doc.data().tipoRegistro == "circuito") {
											let marker = new this.google.maps.Marker({
												position: new this.google.maps.LatLng(
													doc.data().ubicacion.latitude,
													doc.data().ubicacion.longitude
												),
												icon: mCicuito,
												title: "CIRCUITO EXPRESO",
												map: map,
											});
											let infoWindow = new this.google.maps.InfoWindow({
												content: "Circuito Expreso",
											});
											marker.addListener("click", function () {
												infoWindow.open(map, marker);
											});
										}
									} else {
										console.log("=> is NOT in searchArea");
									}
								});
							})
							.catch((error) => {
								console.log("Error getting documents: ", error);
							});
					}
				}
			);
		},
		deleteSelectedShape() {
			if (centroMapa != null) {
				this.showUserLocationOnTheMap(
					centroMapa.geometry.location.lat(),
					centroMapa.geometry.location.lng()
				);
			} else {
				console.log("test");
				navigator.geolocation.getCurrentPosition(
					(position) => {
						console.log(position.coords.latitude);
						console.log(position.coords.longitude + "mi latlong");
						console.log("prueba de imprsion");
						this.showUserLocationOnTheMap(
							position.coords.latitude,
							position.coords.longitude
						);
					},
					(error) => {
						console.log(error.message);
					}
				);
			}
		},

	},
};
</script>

<style scoped>
	.pac-icon {
		display: none;
	}
	.pac-item {
		padding: 10px;
		font-size: 16px;
		cursor: pointer;
	}
	.pac-item:hover {
		background-color: white;
	}
	.pac-item:query {
		font-size: 14px;
	}

	#map {
		position: absolute;
		top: 0%;
		right: 0%;
		bottom: 0%;
		left: 0%;
		background-color: white;
	}
</style>
